/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyCategoryLanguagesResponse } from '../../models/company-category-languages-response';

export interface GetEditorialCompanyCategoriesLanguages$Params {
}

export function getEditorialCompanyCategoriesLanguages(http: HttpClient, rootUrl: string, params?: GetEditorialCompanyCategoriesLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCategoryLanguagesResponse>>> {
  const rb = new RequestBuilder(rootUrl, getEditorialCompanyCategoriesLanguages.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CompanyCategoryLanguagesResponse>>;
    })
  );
}

getEditorialCompanyCategoriesLanguages.PATH = '/api/editorial/company-categories-languages';
